"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeGatsbyServices = void 0;
const geolocationServiceImpl_1 = require("./services/geolocationServiceImpl");
const initializeGatsbyServices = (services) => {
    services.gatsby.geolocationService = new geolocationServiceImpl_1.GeolocationServiceImpl(services.proxy.proxyService);
};
exports.initializeGatsbyServices = initializeGatsbyServices;
//# sourceMappingURL=gatsbyModule.js.map